module.exports = __webpack_public_path__ + "img/b_Anevil_MainView.6737d6e0.jpg";